import { gql, useSubscription } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { Joon3AuditAttributes } from './constants';
import {
  createJoon3AuditAction,
  deleteJoon3AuditAction,
  updateJoon3AuditAction,
} from '../../../../redux-store/joon3-audits-store';

export const Joon3AuditUpdateAttributes = gql`
{
  type
  crud
  id
  new ${Joon3AuditAttributes}
}
`;

export const joon3AuditUpdatesSubscription = gql`
  subscription Joon3AuditUpdates($deviceId: ID!) {
    joon3AuditUpdates(deviceId: $deviceId) ${Joon3AuditUpdateAttributes}
  }
`;

export const tenantJoon3AuditUpdatesSubscription = gql`
  subscription TenantJoon3AuditUpdates($deviceId: ID!) {
    tenantJoon3AuditUpdates(deviceId: $deviceId) ${Joon3AuditUpdateAttributes}
  }
`;

const extract = (result, isTenantAdmin) => {
  if (isTenantAdmin) {
    return result?.data?.tenantJoon3AuditUpdates;
  }
  return result?.data?.joon3AuditUpdates;
};

function useJoon3AuditUpdates(deviceId, isTenantAdmin = false) {
  const queryId = deviceId || 'default';
  const query = isTenantAdmin
    ? tenantJoon3AuditUpdatesSubscription
    : joon3AuditUpdatesSubscription;
  useSubscription(query, {
    skip: !deviceId,
    variables: {
      deviceId,
    },
    fetchPolicy: 'no-cache',
    onSubscriptionData: ({ client, subscriptionData: result }) => {
      try {
        const updates = extract(result, isTenantAdmin);
        if (updates) {
          updates.forEach((update) => {
            switch (update.type) {
              case 'JOON3_AUDIT_CRUD': {
                switch (update.crud) {
                  case 'create':
                    dispatch(createJoon3AuditAction(update.new, queryId));
                    break;
                  case 'read':
                    dispatch(updateJoon3AuditAction(update.new, queryId));
                    break;
                  case 'update':
                    dispatch(updateJoon3AuditAction(update.new, queryId));
                    break;
                  case 'delete':
                    dispatch(deleteJoon3AuditAction(update.id, queryId));
                    break;
                  default:
                    break;
                }
                break;
              }
              default:
                break;
            }
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
  });
  const dispatch = useDispatch();
}

export default useJoon3AuditUpdates;
